module.exports = __webpack_public_path__ + "f9280c1ab322bbb234cbb62e5a6576ab.fbx";